import { Component } from '@angular/core';
import {AlertController, IonicPage, NavController, NavParams} from 'ionic-angular';
import {IntroInsurranceValidationPage} from "../intro-insurrance-validation/intro-insurrance-validation";
import {AppYubleCodePopupPage} from "../app-yuble-code-popup/app-yuble-code-popup";
import {IntroChooseInsurranceCompanyPage} from "../intro-choose-insurrance-company/intro-choose-insurrance-company";
import {ContentTranslationProvider} from "../../providers/content-translation/content-translation";

/**
 * Generated class for the AppRegistrationYubleSelectionPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-registration-yuble-selection',
  templateUrl: 'app-registration-yuble-selection.html',
})
export class AppRegistrationYubleSelectionPage {

  constructor(public navCtrl: NavController, public navParams: NavParams, public alertCtrl: AlertController, public contentTranslation: ContentTranslationProvider) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AppRegistrationYubleSelectionPage');
  }

  showTerms(prefix) {
    const alert = this.alertCtrl.create({
      title: this.contentTranslation.translateContent('Registration Form Modal '+prefix+' title'),
      subTitle: this.contentTranslation.translateContent('Registration Form Modal '+prefix+' text'),
      buttons: [
        {
          text: 'OK',
        },
        {
          text: '×',
          cssClass: 'close-button'
        }

      ],
      cssClass: 'ip-alert ip-with-close'
    });
    alert.present();
  }

  goToInsuranceDetailsValidation() {
    this.navCtrl.push(IntroChooseInsurranceCompanyPage);
  }
  goToYuble() {
    this.navCtrl.push(AppYubleCodePopupPage, {paymentProcess: true})
  }

}



// WEBPACK FOOTER //
// ./src/pages/app-registration-yuble-selection/app-registration-yuble-selection.ts